import { Link } from "react-router-dom";
import StoreHeader from "../../components/layout/StoreHeader";
import StoreFooter from "../../components/layout/StoreFooter";
import { useSettings } from "../../context/SettingsContext";
import { RotateCcw, ArrowRight } from "lucide-react";

const DEFAULT_TEXT = `We offer a 30-day return window on most parts from the date of delivery.

To be eligible for a return, the part must be unused, in its original condition, and accompanied by your order number or proof of purchase.

Electrical parts, items marked as "final sale," and parts that have been fitted or installed are generally not eligible for return unless faulty.

If a part arrives damaged or faulty, please contact us within 7 days of delivery with photos of the issue so we can arrange a replacement or refund quickly.

Once your return is received and inspected, we'll notify you of the approval status and process your refund or credit within 3-5 business days.`;

export default function ReturnsPolicy() {
  const { settings } = useSettings();
  const text = settings.return_policy?.trim() || DEFAULT_TEXT;

  return (
    <div className="bg-white min-h-screen">
      <StoreHeader />

      <div className="bg-[#0b1a3b] py-14">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-[#e31e24] font-mono text-[11px] uppercase tracking-[0.3em] mb-2 flex items-center gap-2">
            <RotateCcw className="h-3.5 w-3.5" /> Customer support
          </div>
          <h1 className="font-heading text-[44px] font-black uppercase text-white leading-tight">
            Returns Policy
          </h1>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 md:px-8 py-12">
        <div className="prose prose-zinc max-w-none whitespace-pre-line text-[15px] leading-relaxed text-zinc-700">
          {text}
        </div>

        <Link to="/returns"
          className="mt-8 inline-flex items-center gap-2 px-5 py-3 bg-[#e31e24] text-white font-heading font-semibold uppercase tracking-wide text-[13px] hover:bg-[#c01a1f] transition-colors rounded-sm">
          Start a Return Request <ArrowRight className="h-4 w-4" />
        </Link>
      </div>

      <StoreFooter />
    </div>
  );
}
